/**
 * Safely converts any value to an array
 * Prevents "is not a function" errors when using array methods
 * 
 * @param {*} value - Value that might or might not be an array
 * @returns {Array} - Always returns a valid array
 * 
 * @example
 * safeArray(null).map(...) // []
 * safeArray(undefined).filter(...) // []
 * safeArray([1,2,3]).slice(...) // [1,2,3]
 * safeArray({}).map(...) // []
 */
export function safeArray(value) {
  return Array.isArray(value) ? value : [];
}